import { combineReducers } from 'redux';
import { defaultModelGroup, defaultSort } from './queryParams';
import leaseFilter from './leaseFilter';
import offers from './offers';
import offerDetails from './offerDetails';
import vehicles from './vehicles';
import zipcode from './zipcode';

const configuration = combineReducers({
  defaultModelGroup,
  defaultSort,
  leaseFilter,
  vehicles,
  offers,
  offerDetails,
  zipcode,
});

export default configuration;
